import React from 'react';
import PropTypes from 'prop-types';

const DangerouslySetInnerHTML = (props) => {
  const { element, html, ...newProps } = props;

  return React.createElement(element, {
    dangerouslySetInnerHTML: {
      __html: html
    },
    ...newProps
  });
};

DangerouslySetInnerHTML.propTypes = {
  element: PropTypes.string,
  html: PropTypes.string.isRequired
};

DangerouslySetInnerHTML.defaultProps = {
  element: 'div'
};

export default DangerouslySetInnerHTML;